import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Solutions from "../pages/services/page";
import SpareParts from "../pages/spare-parts/page";
import Process from "../pages/process/page";
import Contact from "../pages/contact/page";
import { Navigate } from "react-router-dom";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/spare-parts",
    element: <SpareParts />,
  },
  {
    path: "/process",
    element: <Process />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/projects",
    element: <Navigate to="/solutions" replace />,
  },
  {
    path: "/services",
    element: <Navigate to="/solutions" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;